// extracted by mini-css-extract-plugin
module.exports = {"button":"ProfileBackButton_button__oMCNu"};